// ----------------------------------------------------------------------
// <copyright file="Izenda.ReportNameEditorActions.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------
!(function() {
  var compose = require('recompose').compose;
  var withState = require('recompose').withState;
  var withHandlers = require('recompose').withHandlers;
  var { curry, get } = require('lodash/fp');
  var ReportNameEditorActions = compose(
    withState('reportName', 'updateReportName', get('name')),
    withState('editMode', 'updateEditMode', false),
    withHandlers({
      onSave: curry(onSave),
      onCancel: curry(onCancel),
      onEdit: curry(onEdit),
      onKeyPress: onKeyPress,
      onBlur: onBlur,
      onChangeGlobalValue: curry(onChangeGlobalValue)
    })
  );

  function onEdit(props, _) {
    props.updateEditMode(true);
  }

  function onCancel(props, _) {
    props.updateReportName(props.name);
    props.updateEditMode(false);
  }

  function onSave(props, _) {
    var validation = props.validation;
    var reportDesignerModel = props.store.model;
    return validation.validate('reportName').then(function(success) {
      if (success) {
        reportDesignerModel.changeName(props.reportName);
        props.updateEditMode(false);
      }
      return success;
    });
  }

  function onKeyPress(props) {
    return function(e) {
      if (e.key === 'Enter') {
        onSave(props);
      } else if (e.key === 'Escape') {
        onCancel(props);
      }
    };
  }

  function onBlur(props) {
    return function(e) {
      e.preventDefault();
      e.stopPropagation();
      onSave(props);
    };
  }

  /**
   * Update value of global value check box
   * @param {Object}  props
   * @param {Boolean} value
   */
  function onChangeGlobalValue(props, value) {
    var accessStore = props.store.accessStore;

    // validate access list and warning if change to global report
    var result = accessStore.validateAccessListOnUpdateGlobalReport(value, true);

    if (result) {
      props.confirmFn('warning', { description: result }).then(function() {
        // call update global type update
        props.store.changeGlobalType(value);

        // update list access
        accessStore.updateListAccessor(value);
      });
    } else {
      props.store.changeGlobalType(value);
    }
  }

  module.exports = ReportNameEditorActions;
})();



// WEBPACK FOOTER //
// ./ui/modules/ReportDesigner/Izenda.ReportNameEditorActions.js